import Feature10 from './Feature10'
export default Feature10
